/**
 * @file OrderTabSkeleton.tsx
 * @description Заготовка вкладки карточки заказа на время первой загрузки
 * (phase19.31, приёмка qa4 п. 14).
 *
 * Раньше ещё не открывавшаяся вкладка показывала спиннер 24px: блок
 * схлопывался до ~90px, а через полсекунды вырастал до списка — страница
 * прыгала под пальцем. Заготовка — строки списка той же высоты, что у
 * настоящих (`ListSkeleton`), так что высота блока почти не меняется.
 */

import { ListSkeleton } from "../ui/ListStates";

interface Props {
  /** Сколько строк-заготовок; по умолчанию три — типичный объём вкладки. */
  rows?: number;
}

export function OrderTabSkeleton({ rows = 3 }: Props) {
  return <ListSkeleton rows={rows} compact />;
}
